import React, { Component } from 'react';
import { viewMe } from '../services/meService';
import { updateBusinessActiveStatus } from '../services/myBusinessesService';
import BusinessWizardModal from '../components/business/BusinessWizardModal';

class MyBusinessesPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      errorMessage: '',
      successMessage: '',
      businesses: [],
      owner: null,
      isModalOpen: false,
      modalMode: 'add',
      selectedBusiness: null,
      togglingBusinessId: '',
    };
  }

  componentDidMount() {
    this.loadMyBusinesses();
  }

  loadMyBusinesses = () => {
    this.setState({
      loading: true,
      errorMessage: '',
      successMessage: '',
    });

    viewMe()
      .then((response) => {
        this.setState({
          loading: false,
          owner: response.owner || null,
          businesses: response.businesses || [],
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          errorMessage: error.message || 'שגיאה בטעינת העסקים',
        });
      });
  };

  openAddModal = () => {
    this.setState({
      isModalOpen: true,
      modalMode: 'add',
      selectedBusiness: null,
    });
  };

  openEditModal = (business) => {
    this.setState({
      isModalOpen: true,
      modalMode: 'edit',
      selectedBusiness: business,
    });
  };

  closeModal = () => {
    this.setState({
      isModalOpen: false,
      modalMode: 'add',
      selectedBusiness: null,
    });
  };

  handleToggleActive = (business) => {
    const newValue = !(business.is_active !== false);

    this.setState({
      togglingBusinessId: business.id,
      errorMessage: '',
      successMessage: '',
    });

    updateBusinessActiveStatus({
      business_id: business.id,
      is_active: newValue,
    })
      .then(() => {
        this.setState({
          togglingBusinessId: '',
          successMessage: 'סטטוס העסק עודכן בהצלחה',
        });
        this.loadMyBusinesses();
      })
      .catch((error) => {
        this.setState({
          togglingBusinessId: '',
          errorMessage: error.message || 'שגיאה בעדכון סטטוס העסק',
        });
      });
  };

  renderOwnerSummary = () => {
    const { owner, businesses } = this.state;

    return (
      <div className="owner-summary-card">
        <div className="owner-summary-main">
          <h2>{owner ? owner.name : 'בעל עסק'}</h2>
          <p>
            טלפון: <span dir="ltr">{owner ? owner.phone_number : ''}</span>
          </p>
          <p>מספר עסקים: {businesses.length}</p>
        </div>

        <div className="owner-summary-actions">
          <button type="button" className="primary-action-btn" onClick={this.openAddModal}>
            + הוספת עסק חדש
          </button>
        </div>
      </div>
    );
  };

  renderBusinessRow = (business) => {
    const { togglingBusinessId } = this.state;

    return (
      <div className="business-row-card" key={business.id}>
        <div className="business-row-main">
          <div className="business-row-title">{business.name}</div>
          <div className="business-row-meta">
            <span>
              טלפון: <span dir="ltr">{business.phone_number || '-'}</span>
            </span>
            <span>פרופיל הושלם: {business.profile_completed ? 'כן' : 'לא'}</span>
          </div>
        </div>

        <div className="business-row-actions">
          <label className="business-switch-line">
            <span>פעיל</span>
            <input
              type="checkbox"
              checked={business.is_active !== false}
              disabled={togglingBusinessId === business.id}
              onChange={() => this.handleToggleActive(business)}
            />
          </label>

          <button
            type="button"
            className="edit-icon-btn"
            onClick={() => this.openEditModal(business)}
            title="עריכת עסק"
          >
            ✏️
          </button>
        </div>
      </div>
    );
  };

  render() {
    const {
      loading,
      errorMessage,
      successMessage,
      owner,
      businesses,
      isModalOpen,
      modalMode,
      selectedBusiness,
    } = this.state;

    if (loading) {
      return (
        <div className="simple-page">
          <div className="simple-page-card">
            <h2>העסקים שלי</h2>
            <p>טוען נתונים...</p>
          </div>
        </div>
      );
    }

    return (
      <div className="simple-page">
        <div className="products-page-card">
          <div className="products-page-header">
            <div>
              <h2>העסקים שלי</h2>
              <p className="page-subtitle">ניהול עסקים והגדרות עסק</p>
            </div>
          </div>

          {errorMessage && <div className="message-box error-box">{errorMessage}</div>}
          {successMessage && <div className="message-box success-box">{successMessage}</div>}

          {owner && this.renderOwnerSummary()}

          <div className="businesses-list">
            {businesses.length === 0 ? (
              <div className="empty-state">אין עסקים להצגה</div>
            ) : (
              businesses.map((business) => this.renderBusinessRow(business))
            )}
          </div>
        </div>

        <BusinessWizardModal
          isOpen={isModalOpen}
          mode={modalMode}
          businessItem={selectedBusiness}
          owner={owner}
          onClose={this.closeModal}
          onSaved={this.loadMyBusinesses}
        />
      </div>
    );
  }
}

export default MyBusinessesPage;